import validator from 'validator';

export const customValidations = {
  methods: {
    mUuidValidation(elementUuid) {
      return !!validator.isUUID(elementUuid);
    },
  },
};
